import { useLeafletContext } from '@react-leaflet/core';
import { useEffect } from 'react';
import L from 'leaflet';
import '../../leaflet-global';
import 'leaflet.markercluster';

function ClusteredMarkers({
  markers,
  disableClusteringAtZoom,
  iconCreateFunction,
}: {
  markers: L.Marker[];
  disableClusteringAtZoom: number;
  iconCreateFunction: (cluster: L.MarkerCluster) => L.Icon<L.IconOptions> | L.DivIcon;
}) {
  const context = useLeafletContext();

  const markerClusterGroup = new L.MarkerClusterGroup({
    spiderfyOnMaxZoom: false,
    showCoverageOnHover: false,
    disableClusteringAtZoom,
    iconCreateFunction,
  });

  markers.forEach((marker) => {
    markerClusterGroup.addLayer(marker);
  });

  useEffect(() => {
    context.map.addLayer(markerClusterGroup);
    return () => {
      markerClusterGroup.getLayers().forEach((layer) => {
        layer.fire('remove');
      });
      context.map.removeLayer(markerClusterGroup);
    };
  });

  return null;
}

export default ClusteredMarkers;
